export const VelsUniversityCourses = {
    "MPCB (Maths, Physics, Chemistry, Biology)": [
        "BSc Aviation",
        "BSc Aeronautical Science",
        "BBA Aviation Management",
    ],

    "MPCC (Maths, Physics, Chemistry, Computer Science)": [
        "BSc Aviation",
        "BSc Aeronautical Science",
        "BBA Aviation Management"
    ],

    "PCB (Physics, Chemistry, Biology) without Math": [
        "BSc Aeronautical Science",
        "BBA Aviation Management"
    ],

    "Commerce (Accountancy, Commerce, Economics with Maths)": [
        "BBA Aviation Management"
    ],

    "Commerce (Accountancy, Commerce, Economics with Computer Science)": [
        "BBA Aviation Management"
    ],

    "Commerce (Accountancy, Commerce, Economics with Statistics)": [
        "BBA Aviation Management"
    ],

    "History, Geography, Political Science, Economics": [
        "BBA Aviation Management"
    ],

    "History, Geography, Political Science, Sociology": [
        "BBA Aviation Management"
    ],

    "Psychology, Sociology, Economics, Political Science": [
        "BBA Aviation Management"
    ],

    "Fine Arts, History, Geography": [
        "BBA Aviation Management"
    ],

    "Home Science, Psychology, Sociology": [
        "BBA Aviation Management"
    ],

    "Others": [
        "BSc Aviation",
        "BSc Aeronautical Science",
        "BBA Aviation Management"
    ]
};

export const VelsUniversityPGCourses = {
    "Under Graduate": [
        "MBA in Aviation and Management",
    ],

    "Working": [
        "MBA in Aviation and Management",
    ]
};

export const CrescentUniversityCourses = {
    "MPCB (Maths, Physics, Chemistry, Biology)": [
        "BSc Aviation"
    ],

    "MPCC (Maths, Physics, Chemistry, Computer Science)": [
        "BSc Aviation"
    ],

    "Others": [
        "BSc Aviation"
    ]
};

export const BharathUniversityCourses = {
    "MPCB (Maths, Physics, Chemistry, Biology)": [
        "BSc Aviation",
        "BSc Aeronautical Science"
    ],

    "MPCC (Maths, Physics, Chemistry, Computer Science)": [
        "BSc Aviation",
        "BSc Aeronautical Science"
    ],

    "PCB (Physics, Chemistry, Biology) without Math": [
        "BSc Aeronautical Science"
    ],

    "Others": [
        "BSc Aviation",
        "BSc Aeronautical Science"
    ]
};

export const AllianceUniversityCourses = {
    "MPCB (Maths, Physics, Chemistry, Biology)": [
        "BSc Aviation",
        "BBA Aviation Management"
    ],

    "MPCC (Maths, Physics, Chemistry, Computer Science)": [
        "BSc Aviation",
        "BBA Aviation Management"
    ],

    "PCB (Physics, Chemistry, Biology) without Math": [
        "BBA Aviation Management"
    ],

    "Commerce (Accountancy, Commerce, Economics with Maths)": [
        "BBA Aviation Management"
    ],

    "Commerce (Accountancy, Commerce, Economics with Computer Science)": [
        "BBA Aviation Management"
    ],

    "Commerce (Accountancy, Commerce, Economics with Statistics)": [
        "BBA Aviation Management"
    ],

    "History, Geography, Political Science, Economics": [
        "BBA Aviation Management"
    ],

    "History, Geography, Political Science, Sociology": [
        "BBA Aviation Management"
    ],

    "Psychology, Sociology, Economics, Political Science": [
        "BBA Aviation Management"
    ],

    "Fine Arts, History, Geography": [
        "BBA Aviation Management"
    ],

    "Home Science, Psychology, Sociology": [
        "BBA Aviation Management"
    ],

    "Others": [
        "BSc Aviation",
        "BBA Aviation Management"
    ]
};

export const JamalCollegeCourses = {
    "MPCB (Maths, Physics, Chemistry, Biology)": [
        "BBA Aviation Management"
    ],

    "MPCC (Maths, Physics, Chemistry, Computer Science)": [
        "BBA Aviation Management"
    ],

    "PCB (Physics, Chemistry, Biology) without Math": [
        "BBA Aviation Management"
    ],

    "Commerce (Accountancy, Commerce, Economics with Maths)": [
        "BBA Aviation Management"
    ],

    "Commerce (Accountancy, Commerce, Economics with Computer Science)": [
        "BBA Aviation Management"
    ],

    "Commerce (Accountancy, Commerce, Economics with Statistics)": [
        "BBA Aviation Management"
    ],

    "History, Geography, Political Science, Economics": [
        "BBA Aviation Management"
    ],

    "History, Geography, Political Science, Sociology": [
        "BBA Aviation Management"
    ],

    "Psychology, Sociology, Economics, Political Science": [
        "BBA Aviation Management"
    ],

    "Fine Arts, History, Geography": [
        "BBA Aviation Management"
    ],

    "Home Science, Psychology, Sociology": [
        "BBA Aviation Management"
    ],

    "Others": [
        "BBA Aviation Management"
    ]
};

export const ganpatUniversityCourses = {
    "MPCB (Maths, Physics, Chemistry, Biology)": [
        "BBA Aviation Management"
    ],

    "MPCC (Maths, Physics, Chemistry, Computer Science)": [
        "BBA Aviation Management"
    ],

    "PCB (Physics, Chemistry, Biology) without Math": [
        "BBA Aviation Management"
    ],

    "Commerce (Accountancy, Commerce, Economics with Maths)": [
        "BBA Aviation Management"
    ],

    "Commerce (Accountancy, Commerce, Economics with Computer Science)": [
        "BBA Aviation Management"
    ],

    "Commerce (Accountancy, Commerce, Economics with Statistics)": [
        "BBA Aviation Management"
    ],

    "History, Geography, Political Science, Economics": [
        "BBA Aviation Management"
    ],

    "History, Geography, Political Science, Sociology": [
        "BBA Aviation Management"
    ],

    "Psychology, Sociology, Economics, Political Science": [
        "BBA Aviation Management"
    ],

    "Fine Arts, History, Geography": [
        "BBA Aviation Management"
    ],

    "Home Science, Psychology, Sociology": [
        "BBA Aviation Management"
    ],

    "Others": [
        "BBA Aviation Management"
    ]
};

export const BishopCollegeCourses = {
    "MPCB (Maths, Physics, Chemistry, Biology)": [
        "BSc Aviation",
        "BBA Aviation and Ground Handling"
    ],

    "MPCC (Maths, Physics, Chemistry, Computer Science)": [
        "BSc Aviation",
        "BBA Aviation and Ground Handling"
    ],

    "PCB (Physics, Chemistry, Biology) without Math": [
        "BSc Aviation",
        "BBA Aviation and Ground Handling"
    ],

    "Commerce (Accountancy, Commerce, Economics with Maths)": [
        "BBA Aviation and Ground Handling"
    ],

    "Commerce (Accountancy, Commerce, Economics with Computer Science)": [
        "BBA Aviation and Ground Handling"
    ],

    "Commerce (Accountancy, Commerce, Economics with Statistics)": [
        "BBA Aviation and Ground Handling"
    ],

    "History, Geography, Political Science, Economics": [
        "BBA Aviation and Ground Handling"
    ],

    "History, Geography, Political Science, Sociology": [
        "BBA Aviation and Ground Handling"
    ],

    "Psychology, Sociology, Economics, Political Science": [
        "BBA Aviation and Ground Handling"
    ],

    "Fine Arts, History, Geography": [
        "BBA Aviation and Ground Handling"
    ],

    "Home Science, Psychology, Sociology": [
        "BBA Aviation and Ground Handling"
    ],

    "Others": [
        "BSc Aviation",
        "BBA Aviation and Ground Handling"
    ]
};

export const SasurieCollegeCourses = {
    "MPCB (Maths, Physics, Chemistry, Biology)": [
        "BBA (Specialisation in Aviation)"
    ],

    "MPCC (Maths, Physics, Chemistry, Computer Science)": [
        "BBA (Specialisation in Aviation)"
    ],

    "PCB (Physics, Chemistry, Biology) without Math": [
        "BBA (Specialisation in Aviation)"
    ],

    "Commerce (Accountancy, Commerce, Economics with Maths)": [
        "BBA (Specialisation in Aviation)"
    ],

    "Commerce (Accountancy, Commerce, Economics with Computer Science)": [
        "BBA (Specialisation in Aviation)"
    ],

    "Commerce (Accountancy, Commerce, Economics with Statistics)": [
        "BBA (Specialisation in Aviation)"
    ],

    "History, Geography, Political Science, Economics": [
        "BBA (Specialisation in Aviation)"
    ],

    "History, Geography, Political Science, Sociology": [
        "BBA (Specialisation in Aviation)"
    ],

    "Psychology, Sociology, Economics, Political Science": [
        "BBA (Specialisation in Aviation)"
    ],

    "Fine Arts, History, Geography": [
        "BBA (Specialisation in Aviation)"
    ],

    "Home Science, Psychology, Sociology": [
        "BBA (Specialisation in Aviation)"
    ],

    "Others": [
        "BBA (Specialisation in Aviation)"
    ]
};

export const SasurieCollegePGCourses = {
    "Under Graduate": [
        "MBA in Aviation and Management",
        "MBA (Specialization in Aviation)"
    ],

    "Working": [
        "MBA in Aviation and Management",
        "MBA (Specialization in Aviation)"
    ]
};

export const KalasalingamUniversityCourses = {
    "MPCB (Maths, Physics, Chemistry, Biology)": [
        "BSc Aviation",
        "BSc Aeronautical Science",
        "BBA Aviation Management"
    ],

    "MPCC (Maths, Physics, Chemistry, Computer Science)": [
        "BSc Aviation",
        "BSc Aeronautical Science",
        "BBA Aviation Management"
    ],

    "PCB (Physics, Chemistry, Biology) without Math": [
        "BSc Aeronautical Science",
        "BBA Aviation Management"
    ],

    "Commerce (Accountancy, Commerce, Economics with Maths)": [
        "BBA Aviation Management"
    ],

    "Commerce (Accountancy, Commerce, Economics with Computer Science)": [
        "BBA Aviation Management"
    ],

    "Commerce (Accountancy, Commerce, Economics with Statistics)": [
        "BBA Aviation Management"
    ],

    "History, Geography, Political Science, Economics": [
        "BBA Aviation Management"
    ],

    "History, Geography, Political Science, Sociology": [
        "BBA Aviation Management"
    ],

    "Psychology, Sociology, Economics, Political Science": [
        "BBA Aviation Management"
    ],

    "Fine Arts, History, Geography": [
        "BBA Aviation Management"
    ],

    "Home Science, Psychology, Sociology": [
        "BBA Aviation Management"
    ],

    "Others": [
        "BSc Aviation",
        "BSc Aeronautical Science",
        "BBA Aviation Management"
    ]
};

export const KalasalingamUniversityPGCourses = {
    "Under Graduate": [
        "MBA in Aviation and Management",
        "MBA (Specialization in Aviation)"
    ],

    "Working": [
        "MBA in Aviation and Management",
        "MBA (Specialization in Aviation)"
    ]
};

export const SanskritiUniversityCourses = {
    "MPCB (Mathematics, Physics, Chemistry, Biology)": [
        "BSc Aviation",
        "BBA Aviation Management",
        "BTech Aeronautical Engineering"
    ],

    "MPCC (Mathematics, Physics, Chemistry, Computer Science)": [
        "BSc Aviation",
        "BBA Aviation Management",
        "BTech Aeronautical Engineering"
    ],

    "PCB (Physics, Chemistry, Biology) without Math": [
        "BBA Aviation Management"
    ],

    "Commerce (Accountancy, Commerce, Economics with Maths)": [
        "BBA Aviation Management"
    ],

    "Commerce (Accountancy, Commerce, Economics with Computer Science)": [
        "BBA Aviation Management"
    ],

    "Commerce (Accountancy, Commerce, Economics with Statistics)": [
        "BBA Aviation Management"
    ],

    "History, Geography, Political Science, Economics": [
        "BBA Aviation Management"
    ],

    "History, Geography, Political Science, Sociology": [
        "BBA Aviation Management"
    ],

    "Psychology, Sociology, Economics, Political Science": [
        "BBA Aviation Management"
    ],

    "Fine Arts, History, Geography": [
        "BBA Aviation Management"
    ],

    "Home Science, Psychology, Sociology": [
        "BBA Aviation Management"
    ],

    "Others": [
        "BSc Aviation",
        "BBA Aviation Management",
        "BTech Aeronautical Engineering"
    ]
};

export const contactcourses = {
    "MPCB (Mathematics, Physics, Chemistry, Biology)": [
        "BSc Aviation",
        "BBA Aviation Management",
        "BTech Aeronautical Engineering",
        "BSc Aeronautical Science",
        "BBA Aviation and Ground Handling",
        "BBA (Specialisation in Aviation)"
    ],

    "MPCC (Mathematics, Physics, Chemistry, Computer Science)": [
        "BSc Aviation",
        "BBA Aviation Management",
        "BTech Aeronautical Engineering",
        "BSc Aeronautical Science",
        "BBA Aviation and Ground Handling",
        "BBA (Specialisation in Aviation)"
    ],

    "PCB (Physics, Chemistry, Biology) without Math": [
        "BSc Aviation",
        "BBA Aviation Management",
        "BTech Aeronautical Engineering",
        "BSc Aeronautical Science",
        "BBA Aviation and Ground Handling",
        "BBA (Specialisation in Aviation)"
    ],

    "Commerce (Accountancy, Commerce, Economics with Maths)": [
        "BSc Aviation",
        "BBA Aviation Management",
        "BTech Aeronautical Engineering",
        "BSc Aeronautical Science",
        "BBA Aviation and Ground Handling",
        "BBA (Specialisation in Aviation)"
    ],

    "Commerce (Accountancy, Commerce, Economics with Computer Science)": [
        "BSc Aviation",
        "BBA Aviation Management",
        "BTech Aeronautical Engineering",
        "BSc Aeronautical Science",
        "BBA Aviation and Ground Handling",
        "BBA (Specialisation in Aviation)"
    ],

    "Commerce (Accountancy, Commerce, Economics with Statistics)": [
        "BSc Aviation",
        "BBA Aviation Management",
        "BTech Aeronautical Engineering",
        "BSc Aeronautical Science",
        "BBA Aviation and Ground Handling",
        "BBA (Specialisation in Aviation)"
    ],

    "History, Geography, Political Science, Economics": [
        "BSc Aviation",
        "BBA Aviation Management",
        "BTech Aeronautical Engineering",
        "BSc Aeronautical Science",
        "BBA Aviation and Ground Handling",
        "BBA (Specialisation in Aviation)"
    ],

    "History, Geography, Political Science, Sociology": [
        "BSc Aviation",
        "BBA Aviation Management",
        "BTech Aeronautical Engineering",
        "BSc Aeronautical Science",
        "BBA Aviation and Ground Handling",
        "BBA (Specialisation in Aviation)"
    ],

    "Psychology, Sociology, Economics, Political Science": [
        "BSc Aviation",
        "BBA Aviation Management",
        "BTech Aeronautical Engineering",
        "BSc Aeronautical Science",
        "BBA Aviation and Ground Handling",
        "BBA (Specialisation in Aviation)"
    ],

    "Fine Arts, History, Geography": [
        "BSc Aviation",
        "BBA Aviation Management",
        "BTech Aeronautical Engineering",
        "BSc Aeronautical Science",
        "BBA Aviation and Ground Handling",
        "BBA (Specialisation in Aviation)"
    ],

    "Home Science, Psychology, Sociology": [
        "BSc Aviation",
        "BBA Aviation Management",
        "BTech Aeronautical Engineering",
        "BSc Aeronautical Science",
        "BBA Aviation and Ground Handling",
        "BBA (Specialisation in Aviation)"
    ],

    "Others": [
        "BSc Aviation",
        "BBA Aviation Management",
        "BTech Aeronautical Engineering",
        "BSc Aeronautical Science",
        "BBA Aviation and Ground Handling",
        "BBA (Specialisation in Aviation)"
    ]
};

export const contactPGcourses = {
    "Under Graduate": [
        "MBA in Aviation and Management",
        "MBA (Specialization in Aviation)"
    ],

    "Working": [
        "MBA in Aviation and Management",
        "MBA (Specialization in Aviation)"
    ]
};